import { render, staticRenderFns } from "./NewProjectWizard.vue?vue&type=template&id=3521c9c4&"
import script from "./NewProjectWizard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NewProjectWizard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports